import utils from "../common/util";
import * as cmpScoresPage from "../modules/cmp-scores-page"

const cmpPageHeader = {
	component: null,

	init: function (element)
	{
		utils.log('cmpPageHeader initiated : #' + element.id, 'info');

		const _ = utils.setEnvironment(this);
		_.component = element;
		_.buttons = document.getElementsByClassName(' game-header-button');

		_.onClickEvent(element);
	},

	onClickEvent: function (element)
	{
		const _ = this;

		element.addEventListener('click', (e) =>
		{
			let btn = (e.target);
			if (btn.classList.contains('home-icon')) {
				document.location.href = '/home';
			}

			else if (btn.classList.contains('game-scores')) {
				btn.classList.remove('game-scores');
				btn.classList.add('game-scores-close');
				utils.sleep(1000).then(() => {
					btn.setAttribute('name', 'close');
				});
				cmpScoresPage.default.showScoresPanel();
			}

			else if (btn.classList.contains('game-scores-close'))
			{
				cmpScoresPage.default.hideScoresPanel();
				btn.classList.remove('game-scores-close');
				btn.classList.add('game-scores');
				utils.sleep(1000).then(() => {
	                btn.setAttribute('name', 'podium');
                });
			}
		})
	},

	hidePageHeader: function ()
	{
		const _ = this;

		_.component.classList.add('opacity-0')
	},

	showPageHeader: function ()
	{
		const _ = this;

		_.component.classList.remove('opacity-0')
	},

	updateGameLevel: function (name, level)
	{
		const _ = this;

		_.gameLevelNameContainer.innerText = name;
		_.gameLevelNumberContainer.innerText = 'Level ' + level;
	},

	hideGameLevel: function ()
	{
		const _ = this;

		_.gameLevelContainer.classList.add('opacity-0')
	},

	showGameLevel: function ()
	{
		const _ = this;

		_.gameLevelContainer.classList.remove('opacity-0')
	}
}

export default cmpPageHeader;
